import React, { useEffect, useState } from "react"; 
// import { Check, X } from "lucide-react";
import Perfil from "../../../assets/image/Home/perfil.png"; 
import "./ListStudents.css";
import { teacherAPI } from "../../../api/aulasApi"; 

const badgeColors = [
  { background: "#E0F2FE", color: "#5C95C4" },
  { background: "#DBEAFE", color: "#5A7DBC" },
  { background: "#F0F8FF", color: "#6A8CAC" },
  { background: "#E3EEFF", color: "#5A6FBB" },
  { background: "#E6F0FF", color: "#5F739B" }  
];

const getRandomColor = (subject) => {
    if (!subject || typeof subject !== 'string') { 
        return badgeColors[0]; 
    }
    let hash = 0;
    for (let i = 0; i < subject.length; i++) {
        hash = subject.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash; 
    }
    const index = Math.abs(hash) % badgeColors.length;
    return badgeColors[index];
};

export default function ListStudents() {
    /* --- Estados --- */
    const [students, setStudents] = useState([]);

    /* --- Efeitos --- */
    useEffect(() => {
        const fetchStudents = async () => {
            try {
                const response = await teacherAPI.getStudents();

                if (Array.isArray(response.data)) {
                    const formatted = response.data.map((student, index) => ({
                        id: student.id || index + 1, 
                        name: student.nome || "Nome Indisponível",
                        class: student.turma || "Turma Indisponível",
                        subjects: Array.isArray(student.disciplinas) ? student.disciplinas : (student.disciplinas ? [student.disciplinas] : []),
                        present: student.presenca !== undefined ? student.presenca : false, 
                        avatar: student.avatar || Perfil, 
                    }));
                    setStudents(formatted);
                } else {
                    console.error("Erro: os dados recebidos da API não são um array.", response.data);
                    setStudents([]); 
                }
            } catch (error) {
                console.error("Erro ao buscar estudantes:", error);
                setStudents([]); 
            }
        };

        fetchStudents();
    }, []); 

    /* --- Renderização --- */
    return (
        <div className="student-list-container">
            <div className="student-list-card">
                <div className="student-list-header">
                    <div>Nome</div>
                    <div>Turma</div>
                    <div>Disciplina(s)</div> 
                    {/* <div className="text-end">Presença</div> */}
                </div>

                <div className="divide-y"> 
                    {students.map((student) => (
                        <div key={student.id} className="student-list-row">
                            <div className="student-info">
                                <div className="student-avatar">
                                    <img
                                        src={student.avatar}
                                        alt={`Foto de ${student.name}`}
                                    />
                                </div>
                                <div className="student-name">{student.name}</div>
                            </div>

                            <div>{student.class}</div>

                            <div className="subject-badges-container">
                                {student.subjects && student.subjects.length > 0 ? (
                                    student.subjects.map((subject, index) => { 
                                        if (typeof subject !== 'string' || subject.trim() === '') {
                                            return null; 
                                        }
                                        const color = getRandomColor(subject);
                                        return (
                                            <span
                                                key={`${subject}-${index}`}
                                                className="subject-badge"
                                                style={{ backgroundColor: color.background, color: color.color }}
                                            >
                                                {subject}
                                            </span>
                                        );
                                    })
                                ) : (
                                    <span>N/A</span> 
                                )}
                            </div>

                            {/* <div className="presence-indicator">
                                {student.present ? (
                                    <div className="presence-icon presence-present">
                                        <Check className="h-4 w-4" /> 
                                    </div>
                                ) : (
                                    <div className="presence-icon presence-absent">
                                        <X className="h-4 w-4" />
                                    </div>
                                )}
                            </div> */}
                        </div>
                    ))}
                    {students.length === 0 && (
                        <div className="student-list-row student-list-no-data">
                            Nenhum aluno encontrado.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}